import { postRequest } from '@/utils/http'

interface testParams {
  name: string,
  password: string
}
export async function test (params:testParams) {
  return postRequest('https://devpplatform-api.jilingshu.com.cn/backend/auth/login', params)
}
